hrd.components.AbstractComponent = hrd.AbstractCommonInterface.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.AbstractComponent',
			verbose: false,
			formInstance: undefined, // pointer to formInstance
			reference: undefined, // pointer to reference object like a FormDashlet
		};
		this._super($.extend(true, {}, defaults, options));
		this.toolbox = new hrd.Toolbox();
	},
	getFormInstance: function() {
		return this.settings.formInstance;
	},
	getFormInstanceSettings: function() {
		return this.settings.formInstance.settings;
	},
	getFormInstanceSetting: function(setting, fallback) {
		return this.toolbox.get(setting, this.getFormInstanceSettings(), fallback);
	},
	/**
	 * wrapper method on formInstance
	 */
	formInstanceToObject: function(object, options) {
		return this.getFormInstance().toObject(object, options);
	},
	/**
	 * wrapper method on formInstance
	 */
	decorateField: function(field, formData) {
		this.getFormInstance().decorateField(field, formData);
	},
	/**
	 * wrapper method on formInstance
	 */
	addEnhancePhasePromise: function(promise) {
		let fi = this.getFormInstance();
		fi.addPromise(promise, fi.ENHANCE_PHASE_PROMISES);
	},
	/**
	 * wrapper method on formInstance
	 */
	addObjectPhasePromise: function(promise) {
		let fi = this.getFormInstance();
		fi.addPromise(promise, fi.OBJECT_PHASE_PROMISES);
	},
	/**
	 * wrapper method on formInstance
	 */
	getValueByPath: function(obj, path) {
		return this.getFormInstance().getValueByPath(obj, path);
	},
	/**
	 * wrapper method on formInstance
	 */
	setValueByPath: function(obj, path, value) {
		this.getFormInstance().setValueByPath(obj, path, value);
	},
	/**
	 * wrapper method on formInstance
	 */
	utils: function() {
		return this.getFormInstance().utils();
	},
	/**
	 * wrapper method on formInstance
	 */
	showField: function(field) {
		this.getFormInstance().showField(field);
	},
	/**
	 * wrapper method on formInstance
	 */
	hideField: function(field) {
		this.getFormInstance().hideField(field);
	},
	log: function() {
		if (this.settings.verbose) {
			console.log.apply(window, arguments);
		}
	}
});